<template>
  <div id="app">
    <keep-alive :include="keepAlive">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      keepAlive: this.vstore.state.keepAlive
    };
  },
  created() {
    this.getToken();
  },
  methods: {
    getToken() {
      if (this.getQueryString("token") != null) {
        localStorage.setItem("token", this.getQueryString("token"));
      }
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    }
  }
};
</script>

<style lang="less">
@import "assets/css/common";
</style>



// WEBPACK FOOTER //
// src/App.vue